import AudioPlayer from "@/component/AudioPlayer";
import { useState, useEffect, useRef } from "react";
import { useShallow } from 'zustand/react/shallow';
import SummaryPanel from "@/sections/MobileSummary/SummaryPanel";
import summaryCommonStore from "@/store/summaryCommon.store";
import { Tab } from "@/constants/mobile";
import { useLocation } from "react-router-dom";
import useListenSlideUp from "../../hooks/useListenSlideUp";
import TabList from "@/sections/MobileSummary/TabList";
import useFetchSummary from "@/sections/Summary/useFetchSummary";
import { Loading } from "@/component/Loading";
import Header from "./components";
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { morePanelId } from "./const";
import useFetchSummaryStream from "@/sections/Summary/useFetchSummaryStream";
import DocComplete from "@/sections/MobileSummary/DocComplete";
import avPlayerStore from "@/store/avPlayer.store";

export default function AppSummary() {
  const { audioInfo, streamId, fullLoading, audioScTimeList } = summaryCommonStore(useShallow((state) => ({
    audioInfo: state.audioInfo,
    streamId: state.streamId,
    fullLoading: state.fullLoading,
    audioScTimeList: state.audioScTimeList,
  })));

  const location = useLocation();
  const { loading } = useFetchSummary(streamId);
  useFetchSummaryStream(streamId);
  useEffect(() => {
    summaryCommonStore.getState().setIsMobile(true);
    const queryParams = new URLSearchParams(location.search);
    const streamId = queryParams.get("streamId");
    const title = queryParams.get("title");
    setTitle(title || "");
    if (streamId) {
      summaryCommonStore.getState().setStreamId(streamId);
    }
  }, []);

  const [activeTab, setActiveTab] = useState(Tab.summary);
  const [showAudio, setShowAudio] = useState(true);
  const [title, setTitle] = useState("");
  const audioRef = useRef(null);

  const morePanel = document.getElementById(morePanelId);
  useListenSlideUp(
    audioRef.current,
    () => {
      setShowAudio(false);
    },
    {
      excludeELe: morePanel,
    }
  );

  const onIsPlayingChange = (isPlaying: boolean) => {
    avPlayerStore.getState().setIsAudioPlaying(isPlaying);
  };

  const onCurrentNumChange = (val: number) => {
    avPlayerStore.getState().updatePlayingTime(val);
  };

  const onAudioInsLoaded = (audioIns: AudioPlayerIns) => {
    avPlayerStore.getState().setAudioPlayerIns(audioIns);
  };

  return (
    <div className="bg-#F2F3F5 h-full w-full flex flex-col mobile-page relative">
      {fullLoading ? (
        <>
          <div className="absolute left-0 right-0 top-0 bottom-0 bg-#F2F3F5 flex items-center justify-center text-center">
            <Loading />
          </div>
          <div className="px-4 pt-11">
            <Header title={title} showAudio={showAudio} setShowAudio={setShowAudio} />
          </div>
        </>
      ) : (
        <>
          <div className="w-full bg-gradient-to-b from-#CCDCFD to-#F2F3F5 pt-11">
            <div ref={audioRef} className="px-4">
              <Header title={title} showAudio={showAudio} setShowAudio={setShowAudio} />
              {showAudio && (
                <div className="mt-4 pb-6">
                  <AudioPlayer
                    audioInfo={audioInfo}
                    scTimeList={audioScTimeList}
                    onIsPlayingChange={onIsPlayingChange}
                    onCurrentNumChange={onCurrentNumChange}
                    isMobile={true}
                    onAudioInsLoaded={onAudioInsLoaded}
                  />
                </div>
              )}
            </div>
            <div className="mx-4 flex text-mx-tertiary relative h-9 items-center">
              <TabList activeTab={activeTab} setActiveTab={setActiveTab} disabled={loading} fromShare={false} />
            </div>
          </div>
          <div className="flex-1 overflow-auto px-4 pt-4 pb-23.5">
            {activeTab === Tab.summary && <SummaryPanel />}
            {activeTab === Tab.originalText && <DocComplete />}
          </div>
        </>
      )}
    </div>
  );
}
